/**
 * Resa del blocco SE del riepilogo: i token che `summarizeAutomation` produce, messi a video.
 *
 * Esiste come componente — invece di essere JSX copiato nel builder e nella gallery — per la stessa
 * ragione per cui la resa è una funzione sola: le due viste devono raccontare la regola allo stesso
 * modo, e la copia-incolla è il modo più rapido per farle divergere senza accorgersene.
 *
 * I CONNETTIVI vanno in evidenza perché non sono parole come le altre: sono la struttura della
 * regola. Le parentesi (che i token portano già nel testo) dicono come si raggruppa, i connettivi
 * dicono come si lega — insieme rendono leggibile "(A E B) O C" a colpo d'occhio, che è esattamente
 * ciò che una stringa piatta non permetteva.
 */

import type { SummaryToken } from './automationSummary';
import { SUMMARY_PLACEHOLDER } from './automationSummary';

interface AutomationSummaryTokensProps {
  tokens: SummaryToken[];
}

function AutomationSummaryTokens({ tokens }: AutomationSummaryTokensProps) {
  // Nessuna condizione: l'automazione scatta su ogni evento dell'entità. Il segnaposto lo dice
  // senza inventare una frase.
  if (tokens.length === 0) return <>{SUMMARY_PLACEHOLDER}</>;

  return (
    <>
      {tokens.map((token, index) => (
        // I token non hanno id: la lista è ricostruita per intero a ogni cambio dell'automazione e
        // non è riordinabile, quindi l'indice come key è stabile quanto serve.
        <span key={index}>
          {index > 0 && ' '}
          {token.connective ? (
            <strong className="summary-op">{token.text}</strong>
          ) : (
            token.text
          )}
        </span>
      ))}
    </>
  );
}

export default AutomationSummaryTokens;
